import {
    IMPERSONATE_USER_REQUESTED,
    IMPERSONATE_USER_SUCCESS,
    IMPERSONATE_USER_FAILED,
    STOP_IMPERSONATION,
} from './types';

export const impersonateUserRequested = (userId) => ({
    type: IMPERSONATE_USER_REQUESTED,
    payload: userId,
});

export const impersonateUserSuccess = (userData) => ({
    type: IMPERSONATE_USER_SUCCESS,
    payload: userData,
});

export const impersonateUserFailed = (error) => ({
    type: IMPERSONATE_USER_FAILED,
    payload: error,
});

export const stopImpersonation = () => ({
    type: STOP_IMPERSONATION,
});
